<template>
  <div>
    <div
      v-if="hasRx"
      class="d-flex flex-row flex-wrap"
      :class="{ 'justify-sm-space-around': center }"
    >
      <!-- <div class="text-center font-weight-medium align-center">
        Vertexed Refraction
        <v-btn class="d-inline-block ml-2" x-small rounded outlined
          >Clear Rx</v-btn
        >
      </div> -->

      <v-card
        v-for="eye in eyesForRxs"
        :key="eye"
        flat
        :min-height="$vuetify.breakpoint.smAndUp ? 110 : 90"
        :min-width="minCardWidth"
        :color="cardColor"
        class="pa-2 d-flex flex-row align-center"
        style="max-width: 100%"
      >
        <optical-cross-image
          :dimensions="55"
          :obj="rxObjects[eye]"
          type="refraction"
          class=""
          :style="'margin-top: -25px'"
          v-if="showCrosses"
        />
        <div class="d-flex flex-column" :class="textColorClass[eye]">
          <div class="d-flex flex-row align-start">
            <div class="pr-4">
              <div v-if="eyesForRxs.length > 1">
                <span class="text-h4">{{ eye.toUpperCase() }}</span>
              </div>
            </div>
            <div class="">
              <div class="font-weight-bold" :class="textColorClass[eye]">
                <div>{{ dontVertex ? "CL" : "MR" }}: {{ rxString[eye] }}</div>
                <div>
                  <span v-if="!dontVertex">
                    CL: {{ vertexedRxString[eye] }}</span
                  >
                </div>
                <div
                  v-if="
                    includeSphereEquiv && vertexedSphEquiv[eye] && !dontVertex
                  "
                >
                  CL: {{ vertexedSphEquiv[eye] }} (sph equiv)
                </div>
              </div>

              <div v-if="parseFloat(addString) > 0" class="caption">
                <span>{{ addString }} add</span>
                <span v-if="dominantEye == eye"> (Dominant eye)</span>
              </div>
            </div>
            <rx-information-popup
              v-if="rxObjects && rxObjects[eye]"
              :rxObj="rxObjects[eye]"
              :btnColor="iconColorClass[eye]"
              :dontVertex="dontVertex"
              class="ml-2 d-inline-block"
            ></rx-information-popup>
          </div>

          <slot :name="'content_' + eye" class="slotDiv my-2"> </slot>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
// import Name from "../dir/file";
import RxMethods from "@/assets/js/cls/RxMethods";
import StyleUtilities from "@/assets/js/StyleUtilities";
// import RxInformationPopup from './RxInformationPopup.vue';
//import OpticalCrossImage from "./OpticalCrossImage.vue";

export default {
  name: "RxSummaryCardPair",
  components: {
    OpticalCrossImage: () => import("@/components/clStuff/OpticalCrossImage"),
    RxInformationPopup: () => import("@/components/clStuff/RxInformationPopup"),
  },
  mixins: [RxMethods, StyleUtilities],
  props: {
    showCrosses: {
      type: Boolean,
      default: false,
    },
    includeSphereEquiv: {
      type: Boolean,
      default: false,
    },
    center: {
      type: Boolean,
      default: true,
    },
    rxs: null, // an rxObject: {od:RxObject, os:RxObject}
    rxObjectFromStore: null, // if true will look for "rx"" in the store
    dontVertex: null,
    cardColor: {
      type: String,
      default: "#FFFFFF70",
    },
    minCardWidth: null,
  },
  data: function () {
    return {
      // color: { od: "darken-2 green", os: "darken-2 blue" },
      // textColor: {
      //   od: "text--darken-2 green--text",
      //   os: "text--darken-2 blue--text",
      // },
    };
  },
  methods: {
    // nullifyMR(eye) {
    //   this.$store.dispatch("setRx", { eye: eye, rx: null });
    // },
  },
  computed: {
    rxObjects: function () {
      let rtn = null;
      if (this.rxs) rtn = this.rxs;
      if (this.rxObjectFromStore) rtn = this.$store.state.rx;
      return rtn;
    },
    // hasOsRx: function () {
    //   if (!this.rxObjects["os"]) return false;
    //   return !this.isPlano(this.rxObjects["os"]);
    // },
    eyesForRxs: function () {
      let eyes = [];
      if (this.rxObjects?.od) eyes.push("od");
      if (this.rxObjects?.os) eyes.push("os");
      return eyes;
    },
    // vertexedObjects: function() {
    //     let vStr = { od: null, os: null };
    //   if (this.rxObjects.od)
    //     vStr.od =
    //       this.diffVertex(this.rxObjects.od)
    //   if (this.rxObjects.os)
    //     vStr.os =
    //       this.diffVertex(this.rxObjects.os),
    //       0,
    //       this.rxObjects.os.vertex
    //     );
    //   return vStr;
    // },
    hasRx: function () {
      let odRx = this.rxObjects?.od && !this.isPlano(this.rxObjects.od);
      let osRx = this.rxObjects?.os && !this.isPlano(this.rxObjects.os);
      //   console.log("noOd " + odRx);
      //   console.log("noOs " + osRx);
      return odRx || osRx;
    },
    rxString: function () {
      let str = { od: null, os: null };
      if (this.rxObjects.od) str.od = this.prettyString(this.rxObjects.od);
      if (this.rxObjects.os) str.os = this.prettyString(this.rxObjects.os);
      return str;
    },
    vertexedRx: function () {
      let vRx = { od: null, os: null };
      if (this.rxObjects.od)
        vRx.od = this.diffVertex(
          this.rxObjects.od,
          0,
          this.rxObjects.od.vertex
        );

      if (this.rxObjects.os)
        vRx.os = this.diffVertex(
          this.rxObjects.os,
          0,
          this.rxObjects.os.vertex
        );
      return vRx;
    },
    vertexedRxString: function () {
      let vStr = { od: null, os: null };
      let vRx = this.vertexedRx;
      if (vRx.od) vStr.od = this.prettyStringMinus(vRx.od);
      if (vRx.os) vStr.os = this.prettyStringMinus(vRx.os);

      return vStr;
    },
    vertexedSphEquiv: function () {
      let vSeStr = { od: null, os: null };
      let vRx = this.vertexedRx;
      for (const eye of ["od", "os"]) {
        if (vRx[eye]) {
          let obj = this.sphericalEquivalent(vRx[eye]);
          // obj.round = 0.125;
          let str = this.prettyString(obj, 0.125);
          if (str != this.vertexedRxString[eye]) vSeStr[eye] = str;
        }
      }
      return vSeStr;
    },
    addString: function () {
      let add = null;
      if (this.rxObjects.od?.add) {
        add = this.prettyAdd(this.rxObjects.od);
      } else if (this.rxObjects.os?.add) {
        add = this.prettyAdd(this.rxObjects.os);
      }
      return add;
    },
    dominantEye: function () {
      // return this.$store.getters.dominantEye;
      let rtn = null;
      if (this.rxObjects.od?.dominant) rtn = "od";
      if (this.rxObjects.os?.dominant) rtn = "os";
      return rtn;
    },
  },
};
</script>

<style scoped>
/* .eyeRxWidth {
  min-width: 200px;
} */
.slotDiv {
  max-width: 320px;
}
</style>
